const wp = wp_metis;

const isKa = wp.wp_theme === 'HK Master';

const eventCardBg = "bg-ka-grey-light bg-classic-primary40 bg-pride-sky bg-pastel-turquoise-light bg-dark-grey-dark";
const eventCardText = "text-ka-black text-classic-black text-pride-white text-pastel-black text-dark-white";
const eventCardLink = "text-ka-primary text-classic-primary text-pride-cherry text-pastel-primary text-dark-grass";

const accResetClass = "bg-transparent border-0 border-none text-reset shadow-none m-0";

export default (params) => {
  const {
    index,

    hasMultipleTimes,

    cardClass,
    arrow,

    title,
    border,
    tag,

    live,
    moodleLink,
    roomNumbers,
    useOnlineTitle,

    courseDesc,
    courseNumber,
    subjects,
    link,
  } = params;

  let html = `
    <div
      id="${cardClass}__color"
      class="${cardClass}__color ${eventCardBg} ${eventCardText} position-relative"
      style="--left: ${arrow}px;"
    >
      <div
        id="${cardClass}__border"
        class="${cardClass}__border ${border}"
      ></div>

      ${tag ? `<div
        id="${cardClass}__icon"
        class="position-absolute d-block top-0 py-1 px-2 text-white fw-bold body-lg end-0 ${border} ${cardClass}__icon br-b-start-1"
      >${tag}</div>` : ''}


      <div class="accordion-item ${accResetClass} pt-4 pb-3">
        <span
          id="${cardClass}__acc-${index}"
          class="accordion-header d-block ${accResetClass} ps-2 pe-4 py-0"
        >
          <button
            type="button"
            class="accordion-button calendar-card-acc-button collapsed ${accResetClass} p-0"
            data-bs-toggle="collapse"
            data-bs-target="#${cardClass}__acc-${index}__collapse"
            aria-expanded="false"
          >

            <div class="me-auto">
              <div class="text-reset fw-bold me-auto">
                <span class="fw-bold text-reset" id="${cardClass}__title">${title}</span>
                <div class="${hasMultipleTimes ? '' : 'd-inline ps-1'}">

                  ${useOnlineTitle
                    ? `<div
                        id="${cardClass}__title__online"
                        class="d-inline-block text-reset ms-2"
                      >
                        ${isKa
                          ? `<svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="24"
                              height="16"
                              fill="currentColor"
                              class="bi bi-camera-video" viewBox="0 0 16 16"
                            >
                              <path
                                fill-rule="evenodd"
                                d="M0 5a2 2 0 0 1 2-2h7.5a2 2 0 0 1 1.983 1.738l3.11-1.382A1 1 0 0 1 16 4.269v7.462a1 1 0 0 1-1.406.913l-3.111-1.382A2 2 0 0 1 9.5 13H2a2 2 0 0 1-2-2V5zm11.5 5.175 3.5 1.556V4.269l-3.5 1.556v4.35zM2 4a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h7.5a1 1 0 0 0 1-1V5a1 1 0 0 0-1-1H2z"
                              />
                            </svg>
                            <span class="text-reset">
                              IHK BiZ LIVE
                            </span>`
                          :
                          ` <svg id="Ebene_1" xmlns="http://www.w3.org/2000/svg"
                              xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                              height="16px" fill="currentColor"
                              viewBox="0 0 45 45" style="enable-background:new 0 0 200 45;"
                              xml:space="preserve">
                              <style type="text/css">
                                .st0 {font-family: 'ProximaNova-Regular';}
                                .st1 {font-size: 34.3602px;}
                                .st2 {font-size: 25.6017px;}
                              </style>
                              <g>
                                  <path d="M41.9,14.6c-0.7-0.4-1.6-0.3-2.3,0.1l-7.1,4.9c-0.5,0.3-0.6,1-0.3,1.5c0.3,0.5,1,0.6,1.5,0.3l7.1-4.9v17.6l-7.1-4.9
                                      c-0.5-0.3-1.2-0.2-1.5,0.3C31.9,30,32,30.7,32.5,31l7.1,4.9c0.4,0.3,0.8,0.4,1.3,0.4c0.3,0,0.7-0.1,1-0.2c0.7-0.4,1.2-1.2,1.2-2
                                      V16.6C43,15.8,42.6,15,41.9,14.6z M25.5,12.2H7.9c-2.4,0-4.4,2-4.4,4.4v17.6c0,2.4,2,4.4,4.4,4.4h17.6c2.4,0,4.4-2,4.4-4.4V16.6
                                      C29.9,14.2,27.9,12.2,25.5,12.2z M27.7,34.2c0,1.2-1,2.2-2.2,2.2H7.9c-1.2,0-2.2-1-2.2-2.2V16.6c0-1.2,1-2.2,2.2-2.2h17.6
                                      c1.2,0,2.2,1,2.2,2.2V34.2z"/>
                              </g>
                            </svg>
                            <span class="text-reset">
                                HKBiS <sup>LIVE</sup>
                            </span>
                        `}
                      </div>
                    `
                    : `<div
                        id="${cardClass}__title__room"
                        class="d-inline-block text-reset"
                      >
                        <span class=" text-reset"> -Raum</span>
                        <span
                          id="${cardClass}__title__room__number"
                          class="fw-bold text-reset room-nr ${live ? 'event_color--live' : ''}"
                        >${roomNumbers.join(', ')}</span>
                      </div>`
                    }
                </div>
              </div>

              <div class="mt-2">
                <span
                  id="${cardClass}__course"
                  class="text-reset">Kurs: </span><span class="text-reset">${courseDesc}</span>
              </div>
            </div>
          </button>
        </span>
        <div
          id="${cardClass}__acc-${index}__collapse"
          class="accordion-collapse collapse ${accResetClass} p-0"
          aria-labelledby="${cardClass}__acc-${index}"
        >
          <div class="accordion-body ${accResetClass} pb-0 ms-5 ps-2 pe-4 pt-2">
            <div class="">
              <span class="text-reset">Kursnummer:</span> <span id="${cardClass}__course-number" class="text-reset">${courseNumber}</span>
            </div>
            <div class="d-flex mt-2">
              <div class="me-1">
                <span id="${cardClass}__subject" class="text-reset">${subjects.length > 1 ? 'Fächer' : 'Fach'}: </span>
              </div>
              <div class="">
                <span class="text-reset">${subjects.join(', ')}</span>
              </div>
            </div>

            <div class="mt-4">
              <a
                id="${cardClass}__course-link"
                class="fw-bold calendar-card-link ${eventCardLink}"
                role="button"
                href="${link}"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                  viewBox="0 0 320 512"
                >
                  <path d="M96 480c-8.188 0-16.38-3.125-22.62-9.375c-12.5-12.5-12.5-32.75 0-45.25L242.8 256L73.38 86.63c-12.5-12.5-12.5-32.75 0-45.25s32.75-12.5 45.25 0l192 192c12.5 12.5 12.5 32.75 0 45.25l-192 192C112.4 476.9 104.2 480 96 480z"/>
                </svg>
                Zum Kurs
              </a>
            </div>

            ${!isKa && moodleLink ?
              `<div class="mt-n4 w-100 d-flex">
                    <div class="ms-auto">
                        <a
                            class="${eventCardLink} fw-bold bg-transparent border-0 border-none"
                            target="_blank"
                            href="${moodleLink}"
                        >
                            <svg class="fw-normal ms-1 mb-1" fill="currentColor" width="16" height="16" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path d="M320 0c-17.7 0-32 14.3-32 32s14.3 32 32 32l82.7 0L201.4 265.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L448 109.3l0 82.7c0 17.7 14.3 32 32 32s32-14.3 32-32l0-160c0-17.7-14.3-32-32-32L320 0zM80 32C35.8 32 0 67.8 0 112L0 432c0 44.2 35.8 80 80 80l320 0c44.2 0 80-35.8 80-80l0-112c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 112c0 8.8-7.2 16-16 16L80 448c-8.8 0-16-7.2-16-16l0-320c0-8.8 7.2-16 16-16l112 0c17.7 0 32-14.3 32-32s-14.3-32-32-32L80 32z"/></svg>
                            zu Moodle
                        </a>
                    </div>
                </div>`
            : ''}
          </div>
        </div>
      </div>
    </div>
  `;

  html.trim();
  return html;
};




